module.exports = __webpack_public_path__ + "img/LogopricipalChami.267b8d68.png";